module.exports = __webpack_public_path__ + "img/logo.b24942e5.png";